import { TextHelper } from '../../helpers/TextHelper';
import { GlossaryTextSerializer } from './GlossaryTextSerializer';

class CompareSerializer {
  static processText(text, removeBlankParagraphs) {
    return TextHelper
      .separateIntoParagraphs(text, removeBlankParagraphs)
      .map(elem => (elem === 'Si' ? '✓' : elem))
      .map(GlossaryTextSerializer.deSerialize);
  }

  static deSerializeCharacteristic(characteristic) {
    return {
      name: characteristic.Caracteristica,
      id: characteristic.IdCaracteristica,
      firstDescription: CompareSerializer.processText(characteristic.Descripcion1 || '', true),
      secondDescription: CompareSerializer.processText(characteristic.Descripcion2 || '', true),
      firstValue: CompareSerializer.processText(characteristic.Valor1 || '-'),
      secondValue: CompareSerializer.processText(characteristic.Valor2 || '-'),
    };
  }

  static deSerialize(data) {
    return {
      groupName: data.NombreGrupo,
      order: data.Orden,
      characteristics: data.Lineas.map(CompareSerializer.deSerializeCharacteristic),
    };
  }
}

export { CompareSerializer };



// WEBPACK FOOTER //
// ./src/networking/serializers/CompareSerializer.js